// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2lD1U","productName":"Table_productName__RH-Fi"};